import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43b9f07c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://apps.apple.com/us/app/topo-fire/id6446780541?itsct=apps_box_badge&itscg=30200",
  style: {"display":"inline-block","overflow":"hidden","border-radius":"13px","width":"190px","height":"63px"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&releaseDate=1686182400",
    alt: "Download on the App Store",
    style: {"border-radius":"13px","width":"190px","height":"63px"}
  })
], -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" /> ")

import SimpleHeader from "@/components/SimpleHeader.vue";
import GridPage from "@/components/GridPage.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const teamItems = [
  // {
  // 	type: "full-width-section-title",
  // 	title:"The Wildland fire app that you will actually want to use."
  // },
  {
    type: "image",
    bezel: "iPhone14Pro",
    title: "Shared Incident Map",
    subtitle: "Easily collaborate with other firefighters.",
    link: "/info/tf-incidents",
    imgURL: require("@/assets/images/SharedIncidentMap.jpg"),
  },

  {
    type: "image",
    bezel: "iPhone14Pro",
    title: "Manage Incident Personnel",
    subtitle: "Right from your phone",
    link: "/info/tf-manage-personnel",
    imgURL: require("@/assets/images/ManageIncidentPeronel.jpg"),
  },

  {
    type: "image",
    bezel: "iPhone14Pro",
    title: "FREE Incident Response Pocket Guide",
    subtitle: "Customize font size and display themes.",
    imgURL: require("@/assets/images/TopoFireIRPG.jpg"),
  },

  {
    type: "break",
  },

  {
    type: "image",
    bezel: "iPhone14Pro",
    title: "NWCG & ICS Point Symbols",
    subtitle: "Easily add points on the map.",
    link: "/info/tf-nwcg-ics-symbols",
    imgURL: require("@/assets/images/NWCGWaypoints.jpg"),
  },

  {
    type: "image",
    bezel: "iPhone14Pro",
    title: "NWCG & ICS Line Symbols",
    subtitle: "Easily add lines on the map.",
    link: "/info/tf-nwcg-ics-symbols",
    imgURL: require("@/assets/images/NWCGLines.jpg"),
  },

  {
    type: "image",
    bezel: "iPhone14Pro",
    title: "A new app, but not new tech",
    subtitle:
      "Built on the tried and true technology that has powered Topo Maps+ for 10 years.",
    link: "https://topomaps.co",
    linkText: "See Topo Maps+",
    imgURL:
      "https://s3.us-west-2.amazonaws.com/gp.us.images/screenshots/iphone12/planning-elevations.jpeg",
  },

  {
    type: "break",
  },

  {
    type: "image",
    bezel: "iPhone",
    title: "Live Location Sharing",
    subtitle: "See incident personnel locations",
    link: "",
    imgURL: require("@/assets/images/TopoFireLiveLocationSharing.jpg"),
  },

  {
    type: "image",
    bezel: "iPhone",
    title: "Bring Your Own Maps",
    subtitle: "Import your own GeoPDF® maps.",
    link: "/info/geo-spatial-pdfs-tiffs",
    imgURL: require("@/assets/images/TopoFireImportMap.jpg"),
  },

  {
    type: "image",
    bezel: "iPhone",
    title: "Data Collection, Even Offline",
    subtitle: "Collect data and create maps even when offline",
    link: "",
    imgURL: require("@/assets/images/TopoFireWorksOffline.jpg"),
  },

  {
    type: "break",
  },

  {
    type: "image",
    bezel: "iPhone",
    title: "Distance Rings",
    subtitle: "Quickly see distances from a point.",
    link: "",
    imgURL: require("@/assets/images/TopoFireDistanceRings.jpg"),
  },

  {
    type: "image",
    bezel: "iPhone",
    title: "Line of Sight",
    subtitle: "Check for line of sight before you head out, even offline.",
    link: "",
    imgURL: require("@/assets/images/TopoFireLineOfSight.jpg"),
  },

  {
    type: "image",
    bezel: "iPhone",
    title: "Elevation Heat Map",
    subtitle: "Quickly identify areas at certain elevations.",
    link: "",
    imgURL: require("@/assets/images/TopoFIreElevationHeatMap.jpg"),
  },

  {
    type: "image",
    bezel: "iPhone",
    title: "Land Owner Info",
    subtitle: "Check land ownership, even offline. (US Only)",
    link: "",
    imgURL: require("@/assets/images/TopoFireLandOwnerInfo.jpg"),
  },

  {
    type: "image",
    bezel: "iPhone",
    title: "Public Land",
    subtitle: "Easily see areas on public land (US Only).",
    link: "",
    imgURL: require("@/assets/images/TopoFirePublicLand.jpg"),
  },

  {
    type: "image",
    bezel: "iPhone",
    title: "Private Land",
    subtitle: "Identify property boundaries. (US Only)",
    link: "",
    imgURL: require("@/assets/images/TopoFirePrivateLand.jpg"),
  },

  {
    type: "image",
    bezel: "image",
    title: "Works on all your Apple Devices",
    subtitle: "iPad, Mac, iPhone, Apple Watch",
    link: "",
    imgURL: require("@/assets/images/TopoFireWorksOnAllDevices.png"),
    img2x: require("@/assets/images/TopoFireWorksOnAllDevices@2x.png"),
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(SimpleHeader, {
      background: require('@/assets/images/img/headers/wildlandFire-team-header-2.jpg'),
      title: "Topo Fire",
      subtitle: "Collaborative ICS Mapping",
      height: "45vh"
    }, {
      "under-title": _withCtx(() => [
        _hoisted_1,
        _hoisted_2
      ]),
      _: 1
    }, 8, ["background"]),
    _createVNode(GridPage, {
      gridItems: teamItems,
      maxColumns: 2
    })
  ]))
}
}

})